import Model from '../models/model'

const model = new Model({
	name: 'ScopeModelDetail',
	disableDelete: true,
	disableAdd: true,
	disableExport: true,
	readOnly: true,
	pageSize: 5,
	idProperty: '_id',
	allowImport: false,
	columns: [
		{ field: 'ManufacturerName', width: 170, header: 'Manufacturer' },
		{ field: 'ScopeType', header: 'scopeType', width: 120 },
		{ field: 'ScopeModel', width: 120, header: 'ScopeModel' }
	]
});

export const ScopeModelDetail = model;
export default model.createGridBase();